import type { ReactiveControllerHost } from 'lit';
import { CustomError } from '../../../../_ui-core_/base/package/patterns/package/CError';
import App from '../../../../app';
import BaseController, { type EventAction, type IGameController } from '../base-controller';

type emEvent = {
  type: string;
  data: unknown;
};

export default class EmGameController extends BaseController implements IGameController {
  constructor(host: ReactiveControllerHost) {
    super(host, 'em');
  }

  public async getLaunchUrl(forReal: boolean, gameId: string): Promise<string> {
    try {
      const info = await App.instance.casino.getGameLaunchInfo(this.provider, gameId, forReal);

      // temp solution to enable launch with responses returned from provider-integration
      if (info.launchConfig.launchUrl) {
        return info.launchConfig.launchUrl;
      }

      if (!info.launchConfig.serverUrl || !info.launchConfig.operatorId) {
        return Promise.reject(new CustomError('Missing fields in info.launchConfig.', { code: 404 }));
      }

      const searchParams = new URLSearchParams({
        language: EmGameController.formatLanguage(info.language),
        currency: info.currency,
        ...(info.playForReal ? { _sid: info.playForReal.token } : {}),
        ...(info.lobbyUrl ? { casinolobbyurl: info.lobbyUrl } : {}),
      });

      return `${info.launchConfig.serverUrl}/${info.launchConfig.operatorId}/${info.launchConfig.launchId}?${searchParams}`;
    } catch (error: any) {
      return Promise.reject(
        new CustomError(`Failed to get game launch info: ${error.message}`, {
          code: error.code || 500,
          type: error.type,
        }),
      );
    }
  }

  public getLaunchUrlIOs(forReal: boolean, gameId: string, gameBaseUrl: string): Promise<string> {
    window.$app.logger.warn('TODO - NATIVE GAME LAUNCH NOT IMPLEMENTED!', gameBaseUrl);
    return this.getLaunchUrl(forReal, gameId); // TODO
  }

  public handleMessageEvent(data: string | object): EventAction | null {
    window.$app.logger.log('message', data);
    const { type } = data as emEvent;
    switch (type) {
      case 'betExecuted':
        return this.markActivityAndSpinSuccess();
      case 'toggleAudio':
        return this.markActivity();
      case 'updateStake':
        return this.markActivity();
      case 'roundEnded':
        return this.markActivity();
      case 'quit':
        return this.closeGame();
      default:
        return null;
    }
  }

  public handleAdditionalEventListeners(_iframeUrl: string, _iframeEl: HTMLIFrameElement) {
    return;
  }

  private static formatLanguage(code: string): string {
    switch (code) {
      case 'en':
        return 'en';
      default:
        return 'de';
    }
  }
}
